import { getAPIPath, requestGooseAPI } from '../shared/request'
import { TOrderSearchOptions, InvoiceClientDto, CLIENT_INVOICES_BY_PERIOD } from '../types'

export const ClientInvoicesByPeriodService = {
  getData: (
    locationName: string,
    options: TOrderSearchOptions
  ): Promise<{ results: InvoiceClientDto[]; nextToken: string | null }> => {
    const includes = new Set(['location', 'period', 'locationServiceType.serviceType'])
    options.includes?.forEach((include) => includes.add(include))

    return requestGooseAPI<{ results: InvoiceClientDto[]; nextToken: string | null }>({
      url: getAPIPath(CLIENT_INVOICES_BY_PERIOD, { locationId: locationName }),
      method: 'GET',
      params: {
        ...options,
        includes: Array.from(includes),
      },
    })
  },
}
